<template>
  <div>
    <nav-bar />
    
    <router-view />

    <down-footer />
  </div>
</template>


<script>
import NavBar from './views/partials/NavBar';
import DownFooter from './views/partials/Footer';

export default {
  name: 'app',
  components: { NavBar, DownFooter }
}
</script>